import React, { Fragment } from 'react'
import { Switch } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import routes from '../../routes'
import ServerError from '../../components/server-error'
import Route from '../../components/boundary-route'
import ErrorPage from '../../pages/error'
import { useCountryContext } from '../../context'
import { NATIONAL_CONFIG } from '../../config'

import '@scentregroup/ui/fonts/index.css'
import '@scentregroup/ui/tools/reset.css'

const Application = context => {
  const META_INFORMATION =
    useCountryContext() === 'New Zealand'
      ? NATIONAL_CONFIG.nz
      : NATIONAL_CONFIG.au

  return (
    <Fragment>
      <Helmet
        defaultTitle={META_INFORMATION.title}
        meta={META_INFORMATION.meta}
      >
        <html lang={META_INFORMATION.lang} />
        <meta name="description" content={META_INFORMATION.meta.content} />
      </Helmet>
      <ServerError
        renderError={error => (
          <ErrorPage status={context.status} error={error} />
        )}
      >
        <Switch>
          {routes.map(route => (
            <Route
              renderError={({ error }) => (
                <ErrorPage status={context.status} error={error} />
              )}
              key={route.path || 'error'}
              {...route}
            />
          ))}
        </Switch>
      </ServerError>
    </Fragment>
  )
}

export default Application
